import React from 'react';

const Hash = ({ hash, className = 'text-set3' }) => {
	if (hash.length !== 64) return <span>{hash}</span>;
	return (
		<a
			href={`https://tronscan.org/#/transaction/${hash}`}
			target='_blank'
			rel='noreferrer'
			className={className}>
			{hash.substring(0, 5) + '...' + hash.substring(59)}
		</a>
	);
};

export default Hash;
